<app-navbar></app-navbar>

<main>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</main>

<lib-toastify-toast-container></lib-toastify-toast-container>